module.exports = __webpack_public_path__ + "img/zoom-in.8b516cd6.svg";